/**
 * Brand Color Classes - Re-exported from Color Registry
 *
 * This file provides backward compatibility for existing imports.
 * The Color Registry (registry.ts) is now the single source of truth.
 */

import {getColor} from '@/products/flexible-web-toolkit/colors/registry'
import {
	customBrands,
	customBrandChoices,
} from '@/products/flexible-web-toolkit/blocks/helpers'

/**
 * Gets brand color classes for Tailwind CSS styling
 * @param brandColor - The brand color codename
 * @param fallback - Fallback color if brandColor is not found
 * @returns Object with text, bg, border, and hover classes
 */
export function getBrandColorClasses(
	brandColor?: string | null,
	fallback = 'elanco-blue'
): {
	text: string
	bg: string
	border: string
	hover: string
} {
	const colorName = brandColor || fallback

	// Check custom brands first (these have special background/border classes)
	if (customBrandChoices.includes(colorName)) {
		const customBrand = customBrands[colorName]
		return {
			text: `text-${colorName}`,
			bg: customBrand?.background || `bg-${colorName}`,
			border: customBrand?.border || `border-${colorName}`,
			hover: `hover:bg-${colorName}/10`,
		}
	}

	// Check if color exists in registry
	const registryColor = getColor(colorName)
	if (registryColor) {
		return {
			text: `text-${colorName}`,
			bg: `bg-${colorName}`,
			border: `border-${colorName}`,
			hover: `hover:bg-${colorName}/10`,
		}
	}

	// Fallback to default blue
	return {
		text: 'text-blue-600',
		bg: 'bg-blue-600',
		border: 'border-blue-600',
		hover: 'hover:bg-blue-50',
	}
}
